import axios from "axios";
import {
  FETCH_HW_FIND_US,
  CREATE_HW_FIND_US,
  UPDATE_HW_FIND_US,
  DELETE_HW_FIND_US,
  DELETE_M_HW_FIND_US,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function addHwFindUs(item) {
  return {
    type: CREATE_HW_FIND_US,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/hw_find_us/`, item, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchHwFindUs() {
  return {
    type: FETCH_HW_FIND_US,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/hw_find_us/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateHwFindUs(id, data) {
  return {
    type: UPDATE_HW_FIND_US,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/hw_find_us/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteHwFindUs(id) {
  return {
    type: DELETE_HW_FIND_US,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/hw_find_us/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteMultipleHwFindUs(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_M_HW_FIND_US,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/hw_find_us/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
